export default "__VITE_ASSET__DmBevpJ$__"